export const SET_DIGESTS_FETCHING = 'SET_DIGESTS_FETCHING';
export const SET_DIGESTS = 'SET_DIGESTS';
export const SET_DIGESTS_ERROR = 'SET_DIGESTS_ERROR';
export const CLEAN_DIGESTS = 'CLEAN_DIGESTS';
export const ABORT_DIGESTS_REQUEST = 'ABORT_DIGESTS_REQUEST';
export const RESET_DIGESTS_FETCHING = 'RESET_DIGESTS_FETCHING';
export const DIGESTS_CHANGE_DISPLAY = 'DIGESTS_CHANGE_DISPLAY';



// WEBPACK FOOTER //
// ./src/redux_related/digests/actions.js